import { Typography, Box } from '@mui/material';
import React, { useEffect } from 'react';
import { useSettingsContext } from '../context/SettingsContext';
import { useParams, useLocation } from 'react-router-dom';
import RolesAndPermissions from './RolesAndPermissions/RolesAndPermissions';
import { RolesPermissionsProvider } from '../context/RolesAndPermissionsContext';
import Integrations from 'application/routes/settings/components/Integrations/Integrations';
import AIPrompts from './AIPrompts/AIPrompts';
import DocuSealVisibility from './DocuSealVisibility/DocuSealVisibility';
import OrgConfig from './Configuration/OrgConfig.view';
import GeneralOrgConfig from './Configuration/GeneralOrgConfig.view';
import CompanyInformation from './CompanyInformation/CompanyInformation';
import CustomerFacingProfile from './CustomerFacingProfile/CustomerFacingProfile';
import DamageReportConfig from './Configuration/DamageReportConfig.view';
import useOrgData from '../../../hooks/useOrgData';
import DashboardConfig from './Dashboard/DashboardConfig';
import Billing from './PaymentMethods/Billing';
import TaskListManagement from './TaskListManagement/TaskListManagement';

const SettingsContainer = () => {
  const { selectedSetting, setSelectedSetting } = useSettingsContext();
  const { setting } = useParams<{ setting: string }>();
  const location = useLocation();

  // Initialize org data when user navigates to settings
  const { orgData } = useOrgData();

  useEffect(() => {
    // Extract the setting from the URL path (e.g., /settings/payment -> payment)
    const pathSetting = location.pathname
      .split('/settings/')[1]
      ?.split('/')[0]
      ?.split('?')[0];
    const resolved = setting || pathSetting;
    if (resolved) {
      setSelectedSetting(resolved as any);
    }
  }, [setting, location.pathname, setSelectedSetting]);

  const renderSetting = () => {
    switch (selectedSetting) {
      case 'general':
        return <GeneralOrgConfig />;
      case 'company':
        return <CompanyInformation />;
      case 'customer-profile':
        return <CustomerFacingProfile />;
      case 'roles':
        return (
          <RolesPermissionsProvider>
            <RolesAndPermissions />
          </RolesPermissionsProvider>
        );

      case 'integrations':
        return <Integrations />;

      case 'ai':
        return <AIPrompts />;
      case 'config':
        return <OrgConfig />;
      case 'damage-report':
        return <DamageReportConfig />;

      case 'dashboard':
        return <DashboardConfig />;

      case 'deals':
        return (
          <Typography style={{ color: 'red' }}>
            Deals and Properties Settings
          </Typography>
        );
      case 'hierarchy':
        return (
          <Typography style={{ color: 'red' }}>Hierarchy Settings</Typography>
        );
      case 'docuseal':
        return <DocuSealVisibility orgData={orgData} />;
      case 'payment':
        return <Billing />;
      case 'task-list':
        return <TaskListManagement />;
      default:
        return (
          <Typography style={{ color: 'red' }}>
            Select a setting from the sidebar
          </Typography>
        );
    }
  };

  return <Box sx={{ mt: 17, mx: 4, flexGrow: 1 }}>{renderSetting()}</Box>;
};

export { SettingsContainer };
